import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token JWT
api.interceptors.request.use((config) => {
  // Tenta sessionStorage primeiro (novo), depois localStorage (legado)
  const authStorage = sessionStorage.getItem('auth-storage') || localStorage.getItem('auth-storage');
  if (authStorage) {
    try {
      const { state } = JSON.parse(authStorage);
      if (state?.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
    } catch {
      // Ignora erro de parse
    }
  }
  return config;
});

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('auth-storage');
      localStorage.removeItem('auth-storage');
      // Não redireciona automaticamente - deixa o componente decidir
    }
    return Promise.reject(error);
  }
);

export default api;
